// src/components/ui/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Building2, Send, Search, Settings, Download, Menu } from 'lucide-react';
import './ui.css';

const Header = ({ 
  onOpenSearch, 
  onOpenProfile, 
  handleSendWhatsAppReport, 
  activeShift, 
  handleVoiceClick,
  onDownloadReport 
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // 🌟 बाहर कहीं भी क्लिक करने पर मेनू बंद करने का लॉजिक 🌟
  useEffect(() => {
      const handleClickOutside = (event) => {
          if (isMenuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
              setIsMenuOpen(false);
          }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  const iconBtnSquare = { 
    width: '28px', height: '28px', borderRadius: '8px', 
    border: '1px solid rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.3)', 
    display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' 
  };

  const menuItemStyle = { 
    display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', 
    borderRadius: '8px', background: 'transparent', border: 'none', 
    cursor: 'pointer', width: '100%', textAlign: 'left' 
  };

  return (
    <div style={{
      background: '#ffffff', borderBottom: '1px solid #e2e8f0', boxShadow: '0 4px 15px rgba(0,0,0,0.03)',
      padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent:'space-between', 
      position:'sticky', top:0, zIndex:10
    }}>
      <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
        
        {/* Logo Box */}
        <div style={{width:'28px', height:'28px', borderRadius:'8px', background: 'linear-gradient(135deg, #E0E7FF, #A5B4FC)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink: 0, boxShadow:'0 2px 6px rgba(79, 70, 229, 0.2)'}}>
            <Building2 size={14} color="#4338CA" />
        </div>
        <div>
            <h1 style={{fontSize:'16px', fontWeight:'700', color:'#0F172A', margin:0, lineHeight: 1, letterSpacing:'-0.5px'}}>MukadamPro</h1>
            <div style={{fontSize:'8px', color:'#64748B', fontWeight:'700', marginTop: '2px', letterSpacing: '0.8px', textTransform: 'uppercase'}}>Live Dashboard</div>
        </div>
      </div>
      
      {/* 🌟 HAMBURGER (3-LINE) MENU CONTAINER 🌟 */}
      <div ref={menuRef} style={{ position: 'relative' }}>
          <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)} 
              style={{ ...iconBtnSquare, background: isMenuOpen ? '#f1f5f9' : '#f8fafc', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.02)', transition: 'all 0.2s' }}
          >
              <Menu size={16} color="#0F172A" />
          </button>

          {isMenuOpen && (
              <>
                  {/* Background Overlay (Kahin bhi click karne par menu band karne ke liye fallback) */}
                  <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 99 }} onClick={() => setIsMenuOpen(false)} />
                  
                  <div style={{ position: 'absolute', top: '120%', right: 0, background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', padding: '6px', display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '220px', zIndex: 100 }}>
                      
                      {/* 1. PROFILE & SETTINGS BUTTON (TOP) */}
                      <button onClick={(e) => {
                          setIsMenuOpen(false);
                          if (handleVoiceClick) {
                              handleVoiceClick(e, " ये कंट्रोल केंद्र है, यहाँ से आप प्रोफाइल और सेटिंग्स बदल सकते हैं।", onOpenProfile, 'btn-profile');
                          } else if (onOpenProfile) {
                              onOpenProfile();
                          }
                      }} style={menuItemStyle}>
                          <Settings size={14} color="#475569" />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>Profile & Settings</span>
                      </button>

                      {/* 2. SEARCH BUTTON */}
                      <button onClick={(e) => {
                          setIsMenuOpen(false);
                          if (handleVoiceClick) {
                              handleVoiceClick(e, " ये सर्च बटन है, इस सर्च बटन की मदद से, आप किसी भी तारीख का प्रोडक्शन रिकॉर्ड आसानी से ढूँढ कर देख सकते हैं।", onOpenSearch, 'btn-search');
                          } else if (onOpenSearch) {
                              onOpenSearch();
                          }
                      }} style={menuItemStyle}>
                          <Search size={14} color="#475569" />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>Search Records</span>
                      </button>

                      {/* 3. WHATSAPP REPORT BUTTON */}
                      <button onClick={(e) => {
                          setIsMenuOpen(false);
                          if (handleSendWhatsAppReport) {
                              if (handleVoiceClick) {
                                  handleVoiceClick(e, "ये व्हाट्सएप रिपोर्ट बटन है, इस पर क्लिक करके आप शिफ्ट की पूरी रिपोर्ट अपने और वर्कर्स के व्हाट्सएप पर भेज सकते हैं।", () => handleSendWhatsAppReport(activeShift), 'btn-wa-report');
                              } else {
                                  handleSendWhatsAppReport(activeShift);
                              }
                          }
                      }} style={menuItemStyle}>
                          <Send size={14} color="#059669" />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#059669' }}>Send WhatsApp Report</span>
                      </button>

                      {/* 🌟 DIVIDER LINE 🌟 */}
                      <div style={{ height: '1px', background: 'rgba(0, 0, 0, 0.05)', margin: '2px 4px', borderRadius: '1px' }}></div>

                      {/* 4. PDF DOWNLOAD BUTTON (BOTTOM) */}
                      <button onClick={(e) => {
                          setIsMenuOpen(false);
                          if (handleVoiceClick) {
                              handleVoiceClick(e, " पीडीएफ रिपोर्ट डाउनलोड करने के लिए इसे दबाएं।", onDownloadReport, 'header-pdf-trigger');
                          } else if (onDownloadReport) {
                              onDownloadReport();
                          }
                      }} style={menuItemStyle}>
                          <Download size={14} color="#0F172A" />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#0F172A' }}>Production Report</span>
                      </button>

                  </div>
              </>
          )}
      </div>
    </div>
  );
};

export default Header;